import { Button, Result } from "antd";
import MainScreen from "./MainScreen";

function ErrorFallback({ error, resetErrorBoundary }) {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <MainScreen>
      <Result
        status="500"
        title="Désolé, une erreur est survenue"
        subTitle={
          <>
            <span><b>Veuillez ré-essayer.</b> Si le problème persiste, vous pouvez contacter nos équipes techniques par téléphone (<b>01 84 80 80 41</b>) ou par email (<b>technique@ravail.fr</b>) !</span><br/>
            <span>Nous sommes une petite équipe et nous faisons de notre mieux pour corriger les erreurs, vos retours nous aident à nous améliorer rapidement.</span>
            {error && <pre style={{color: "#f97575"}}>Message d'erreur : <br/>{error.message}</pre>}
          </>
        }
        extra={[
          <Button key="accueil" onClick={() => window.location.href = "/"}>
            Retour à l'accueil
          </Button>,
          <Button key="retry" type="primary" onClick={resetErrorBoundary}>
            Ré-essayer
          </Button>
        ]}
      />
    </MainScreen>
  );
}

export default ErrorFallback;